import { Injectable, Signal } from '@angular/core';
import { ActivatedRouteSnapshot,
  Params,
  Router,
  UrlSegment } from '@angular/router';
import { AppStore } from 'src/app/store/app.store';
import { defaultLanguage, languages } from 'src/constants/languages.constants';
import { RouteQuery, RouteService } from '../../store';
import { PageService } from './page.service';

@Injectable({
  providedIn: 'root',
})
export class RouteToPageDataService {
  protected $hostUrl: Signal<string>;

  constructor(
    private routeQuery: RouteQuery,
    private routeService: RouteService,
    private pageService: PageService,
    private appStore: AppStore,
    private router: Router,
  ) {
    this.$hostUrl = this.appStore.$hostUrl;
  }

  private _getSlug(url: UrlSegment[]) {
    return url.reduce((acc: string, segment: UrlSegment) => {
      return acc + (segment.path ? '/' : '') + segment.path;
    }, '');
  }

  public async getPageData(snapshot: ActivatedRouteSnapshot): Promise<Page> {
    if (!this.$hostUrl()) throw new Error('Host URL not set');
    this.routeQuery.get();
    try {
      return await this.SetRoute(
        snapshot.url,
        snapshot.queryParams,
      );
    } catch (error: any) {
      if (error.status == 401) {
        await this.router.navigate(['/'], {
          queryParams: {
            loginModal: 1,
            redirectUrl: this._getSlug(snapshot.url),
          },
        });
      }
      throw error;
    }
  }

  public async SetRoute(
    url: UrlSegment[],
    queryParams: Params,
  ): Promise<Page> {
    const currentRoute = this.routeQuery.get();
    const slug = this._getSlug(url).substring(1) ?? '';

    let language;
    if (queryParams['lang'] != undefined) {
      language =
        languages.find((language) => language.code === queryParams['lang']) ??
        defaultLanguage;
    } else {
      language = currentRoute?.language ?? defaultLanguage;
    }

    let preview = false;
    if (queryParams['preview'] != undefined) {
      preview = queryParams['preview'] == 'true';
    }

    if (
      currentRoute.param != slug ||
      currentRoute.language?.code != language?.code ||
      currentRoute.preview != preview
    ) {
      this.routeService.set({
        language,
        param: slug,
        preview: preview,
      });
    }

    //At the moment we are explicitly returning page data even if already set.
    if (preview) {
      try {
        return this.pageService.pageContentPreview(
          this.$hostUrl(),
          language.code,
          slug,
        );
      } catch (error) {
        if (console.log) console.log(error);
        throw error;
      }
    } else {
      try {
        return this.pageService.pageContent(
          this.$hostUrl(),
          language.code,
          slug,
        );
      } catch (error) {
        if (console.log) console.log(error);
        throw error;
      }
    }
  }
}
